<template>
    <div class="curriculum content">
        <CourseBread />
        <div class="curr_btn">
            <!--<Button v-if="$route.query.courseStatus == 2" type="primary" @click="addSection()">添加章节</Button>-->
            <Button type="primary" @click="addSection()">添加课节</Button>
        </div>
        <div class="curr_tab">
            <Table :loading="loading" border ref="selection" :columns="columns" :data="sectionList"></Table>
            <!--<div>-->
            <!-- <page-component class="page" :total-num="totalNum" :page-num="pageNum" v-on:changePage="changePage" v-on:changePageSize="changePageSize" v-on:clickPage="clickPage"></page-component> -->
            <!--</div>-->
        </div>
    </div>
</template>
<style scoped>
.curr_tab {
    padding: 10px 0;
}

.course_div {
    margin-bottom: 10px;
}

.courseName {
    color: #000;
    font-size: 14px;
}

.bgImgSet {
    color: #666;
    font-size: 14px;
}

.course {
    margin-left: 6px;
    color: #ccc;
    font-size: 14px;
}

.courseTi {
    margin-left: 6px;
    font-size: 13px;
    color: #000;
}

.page {
    margin-top: 20px;
}
</style>
<script>
import http from "../../libs/http.js";
import pageComponent from "../common/page.vue";
import { mapActions, mapGetters } from "vuex";
import CourseBread from './components/CourseBread.vue'

export default {
    data() {
        return {
            loading: false,
            courseId: this.$route.query.courseId,
            courseTitle: this.$route.query.courseTitle,
            columns: [
                {
                    title: "No.",
                    type: "index",
                    width: 60
                },
                {
                    title: "课节名称",
                    key: "title"
                },
                {
                    title: "主题图",
                    key: "themeUrl",
                    align: "center",
                    render: (h, params) => {
                        return params.row.themeUrl
                            ? h("img", {
                                  attrs: {
                                      src: params.row.themeUrl
                                  },
                                  style: {
                                      height: "70px",
                                      marginTop: "5px"
                                  }
                              })
                            : h("span", "暂无图片");
                    }
                },
                /*{
                    title: "状态",
                    key: "status",
                    align: "center",
                    //                        width: 90,
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "span",
                                {
                                    style: {
                                        color:
                                            params.row.status == 1
                                                ? "#19be6b"
                                                : "#ed4014"
                                    }
                                },
                                params.row.status == 1 ? "已上架" : "未上架"
                            )
                        ]);
                    }
                },*/
                {
                    title: "创建时间",
                    key: "createTime",
                    align: "center",
                    render: (h, params) => {
                        const date = new Date(params.row.createTime);
                        const formattedDate = `${date.getFullYear()}-${
                            (date.getMonth() + 1).toString().padStart(2, '0')
                        }-${date.getDate().toString().padStart(2, '0')} ${
                            date.getHours().toString().padStart(2, '0')
                        }:${date.getMinutes().toString().padStart(2, '0')}:${
                            date.getSeconds().toString().padStart(2, '0') // 添加秒的显示
                        }`;

                        return h("div", formattedDate);
                    }
                },
                {
                    title: "操作",
                    key: "action",
                    width: 470,
                    fixed: "right",
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    height: "70px",
                                    paddingTop: "25px"
                                }
                            },
                            [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "success",
                                            size: "small",
                                            disabled:
                                                this.getLimit == 1 ||
                                                this.getLimit == 6 ||
                                                this.getLimit == 11
                                                    ? false
                                                    : true
                                        },
                                        style: {
                                            marginRight: "10px"
                                        },
                                        on: {
                                            click: () => {
                                                this.addMaterial(params.row);
                                            }
                                        }
                                    },
                                    "课程资料"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                            disabled:
                                                params.row.status == 1
                                                    ? this.getLimit == 1 ||
                                                      this.getLimit == 6 ||
                                                      this.getLimit == 11
                                                        ? false
                                                        : true
                                                    : false
                                        },
                                        style: {
                                            marginRight: "10px"
                                        },
                                        on: {
                                            click: () => {
                                                this.addSection(params.row);
                                            }
                                        }
                                    },
                                    "编辑课节"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "10px"
                                        },
                                        on: {
                                            click: () => {
                                                this.partList(params.row);
                                            }
                                        }
                                    },
                                    "part列表"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                            disabled:
                                                this.getLimit == 1 ||
                                                this.getLimit == 6 ||
                                                this.getLimit == 11
                                                    ? false
                                                    : true
                                        },
                                        style: {
                                            // marginTop: '3px',
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteSection(
                                                    params.row.groupId
                                                );
                                            }
                                        }
                                    },
                                    "删除"
                                ),
                                h("ButtonGroup", [
                                    h("Button", {
                                        props: {
                                            type: "info",
                                            size: "small",
                                            icon: "ios-arrow-up",
                                            ghost: true
                                        },
                                        style: {
                                            marginLeft: "100px"
                                        },
                                        on: {
                                            click: () => {
                                                this.move(params.row, 0);
                                            }
                                        }
                                    }),
                                    h("Button", {
                                        props: {
                                            type: "info",
                                            size: "small",
                                            icon: "ios-arrow-down",
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: "4px"
                                        },
                                        on: {
                                            click: () => {
                                                this.move(params.row, 1);
                                            }
                                        }
                                    })
                                ])
                            ]
                        );
                    }
                }
            ],
            sectionList: [],
            totalNum: 0,
            pageNum: 1,
            pageSize: 10
        };
    },

    created: function() {
        this.getSection(this.pageNum, this.pageSize);
    },
    methods: {
        ...mapActions(["setRecord"]),
        back() {
            this.$router.go(-1);
        },
        // //当前页数
        // changePage(data) {
        //     this.pageNum = data;
        //     this.getSection(this.pageNum, this.pageSize);
        // },
        // //点击切换页数
        // clickPage(data) {
        //     this.pageNum = data;
        //     this.getSection(this.pageNum, this.pageSize);
        // },
        // //当前每页显示的条数
        // changePageSize(data) {
        //     this.pageSize = data;
        //     this.getSection(this.pageNum, this.pageSize);
        // },
        //获取sectionList表格
        getSection(num, pageSize) {
            let _this = this;
            _this.loading = true;
            http.get("/madyGroup/list", {
                courseId: _this.courseId,
                // pageNum: num,
                // pageSize: pageSize
            }).then(res => {
                //                    if (num > res.pages && res.pages != 0) {
                //                        _this.pageNum = res.pages
                //                        _this.getSection(res.pages, pageSize)
                //                    } else {
                //                        _this.loading = false;
                //                        _this.sectionList = res.list
                //                        _this.totalNum = res.total
                //                    }
                _this.loading = false;
                _this.sectionList = res;
                _this.setScrollTop();
            });
        },
        // 根据vuex滚动至指定位置
        setScrollTop() {
            let record = this.getRecord;
            if (record && record.path && record.path == this.$route.path) {
                this.$nextTick(() => {
                    document.body.scrollTop = record.top;
                    document.documentElement.scrollTop = record.top;
                });
                this.setRecord(null);
            } else {
                this.setRecord(null);
            }
        },
        //添加
        addSection(row) {
            const { type, courseStatus, courseId, courseTitle } = this.$route.query;
            if (row) {
                this.recordTop();
                this.$router.push({
                    path: "addSection",
                    query: {
                        type, courseStatus, courseId, courseTitle,
                        groupId: row.groupId,
                        sectionName: row.title,
                    }
                });
            } else {
                this.$router.push({
                    path: "addSection",
                    query: { 
                        type, courseStatus, courseId, courseTitle,
                     }
                });
            }
        },
        //添加
        addMaterial(row) {
            if (row) {
                this.recordTop();
                const { type, courseStatus, courseId, courseTitle } = this.$route.query;

                this.$router.push({
                    path: "/course-material",
                    query: {
                        type, courseStatus, courseId, courseTitle,
                        groupId: row.groupId,
                        sectionName: row.title
                    }
                });
            }
        },
        // 记录跳转前位置信息
        recordTop() {
            this.setRecord({
                path: this.$route.path,
                top:
                    document.documentElement.scrollTop ||
                    document.body.scrollTop ||
                    window.pageYOffset
            });
        },
        //跳到part列表
        partList(row) {
            if (row) {
                this.recordTop();
                const { type, courseStatus, courseId, courseTitle } = this.$route.query;
                this.$router.push({
                    path: "part",
                    query: {
                        type, courseStatus, courseId, courseTitle,
                        groupId: row.groupId,
                        sectionName: row.title,
                        sectionStatus: row.status
                    }
                });
            }
        },
        deleteSection(groupId) {
            let _this = this;
            this.$Modal.confirm({
                title: "提示",
                content: "确定删除该章节?",
                onOk: () => {
                    http.post("/madyGroup/deletes", [groupId]).then(res => {
                        if (res) {
                            //                                _this.getSection(_this.pageNum, _this.pageSize)
                            _this.getSection();
                            _this.$Message.success("删除成功");
                        }
                    });
                }
            });
        },
        // 移动
        move(row, type) {
            http.post("/madyGroup/move", {
                groupId: row.groupId,
                courseId: this.courseId,
                up: type
            }).then(res => {
                if (res) {
                    this.getSection();
                }
            });
        },
        // 上,下架
        changeStatus(groupId, status) {
            let _this = this;
            this.$Modal.confirm({
                title: "提示",
                content: "确定" + (status == 1 ? "上架" : "下架") + "该章节?",
                onOk: () => {
                    http.post("/madyGroup/save", {
                        groupId: groupId,
                        status: status
                    }).then(res => {
                        if (res) {
                            //                                this.getSection(this.pageNum, this.pageSize)
                            this.getSection();
                            _this.$Message.success(
                                status == 1 ? "上架成功" : "下架成功"
                            );
                        }
                    });
                }
            });
        }
    },
    components: {
        pageComponent,
        CourseBread,
    },
    // beforeRouteEnter(to, from, next) {
    //     next(vm => {
    //         if (
    //             from.path == "/gogo/addSection" ||
    //             from.path == "/gogo/detail/editSection" ||
    //             from.path == "/gogo/detail/step"
    //         ) {
    //             vm.setPageNum(from.query.page);
    //         } else {
    //             vm.setPageNum(1);
    //         }
    //         // 通过 `vm` 访问组件实例
    //     });
    // },
    computed: {
        ...mapGetters(["getLimit", "getRecord"])
    }
};
</script>
